// extracted by mini-css-extract-plugin
module.exports = {"Hero":"Hero_Hero__OZthY","Email":"Hero_Email__2rA96"};